module.exports = __webpack_public_path__ + "static/property-app-3-3437c018cca6a5e802c87842fbd359ac.png";